import { render } from "./myEvent.vue?vue&type=template&id=0c8d3a28&scoped=true"
import script from "./myEvent.vue?vue&type=script&lang=js"
export * from "./myEvent.vue?vue&type=script&lang=js"

import "./myEvent.vue?vue&type=style&index=0&id=0c8d3a28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c8d3a28"]])

export default __exports__